var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconShadedSphereLight = function SvgIconShadedSphereLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_shaded_sphere_light_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.999,
    cy: 8.61,
    fill: "#929292",
    rx: 6.075,
    ry: 7.286,
    transform: "rotate(31.392 7.999 8.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.569,
    cy: 7.126,
    fill: "#C1C1C1",
    rx: 2.713,
    ry: 4.18,
    transform: "rotate(31.392 5.57 7.126)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 18.5,
    x: 0.75,
    y: 0.75,
    stroke: "#000",
    strokeWidth: 1.5,
    rx: 9.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_shaded_sphere_light_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    rx: 10
  })))));
};
export default SvgIconShadedSphereLight;